import React from "react";
import { Form, Dropdown } from "semantic-ui-react";

let ButtonRow = props => (
  <Form>
    <Form.Group inline>
      {React.Children.map(props.children, child => (
        <Form.Field>{child}</Form.Field>
      ))}
    </Form.Group>
  </Form>
)

let MaterialDropdown = props => <Dropdown selection {...props} button />

export { ButtonRow, MaterialDropdown }
